<template>
    <b-overlay
    :show="isloading"
    variant="black"
    :opacity="0.8"
    spinner-variant="white"
    rounded="x3"
  >
  <template #overlay>
    <!--데스크톱 안내-->
        <div class="text-center d-none d-md-block d-lg-block d-xl-block">
          <div v-if="isInit">
            <b-img
                  fluid
                  src="./img/guide.png"
                  alt="Basic"
                />
            <b-button
            v-if="ancTrigger"
            style="padding-left:2%;font-family:'NanumBarunGothic';width:50%"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            >
            <b-spinner small />
            </b-button>
            <b-button
              v-else
              style="padding-left:2%;font-family:'NanumBarunGothic';width:50%"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="closeAncModal()"
            >
              확인
            </b-button>

            <div class="mt-3">
              <p style="color:white;font-family:'NanumBarunGothic">지적도를 포함한 모든 정보는 참고용으로만 사용하시기 바랍니다</p>
            </div>
          </div>
          <div v-else>
            <b-icon color="white" icon="stopwatch" font-scale="4" animation="cylon"></b-icon>
            <div class="mb-1">
            </div>
            <p  style="color:white;font-family:'NanumBarunGothic'">잠시만 기다려주세요</p>
          </div>
        </div>

        <div class="text-center d-block d-md-none d-lg-none d-xl-none">
          <div v-if="isInit">
            <b-img
                  class="mt-1 mb-1"
                  fluid
                  src="./img/guideM1.png"
                  alt="Basic"
                />
            <b-carousel
              class="mt-1 mb-3"
              id="carousel"
              v-model="slide"
              :interval="3000"
              background="transparent"
              img-width="500"
              style="text-shadow: 1px 1px 2px #333;"
            >
              <b-carousel-slide
                img-src="./img/guideM2.png"
              ></b-carousel-slide>
              <b-carousel-slide
              img-src="./img/guideM3.png"
              ></b-carousel-slide>
              <b-carousel-slide
              img-src="./img/guideM4.png"
              ></b-carousel-slide>
              <b-carousel-slide
              img-src="./img/guideM5.png"
              ></b-carousel-slide>
            </b-carousel>

            <b-button
            v-if="ancTrigger"
            class="text-center"
            style="font-family:'NanumBarunGothic';width:100%"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            >
            
            <b-spinner small />
            </b-button>
            <b-button
              v-else
              class="text-center"
              style="font-family:'NanumBarunGothic';width:100%"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="closeAncModal()"
            >
              확인
            </b-button>

            <div style="margin-left:-25%;width:150%" class="mt-2">
              <p style="color:white;font-family:'NanumBarunGothic">지적도를 포함한 모든 정보는 참고용으로만 사용하시기 바랍니다</p>
            </div>
          </div>

          <div v-else>
            <b-icon color="white" icon="stopwatch" font-scale="4" animation="cylon"></b-icon>
            <div class="mb-1">
            </div>
            <p style="color:white;font-family:'NanumBarunGothic'">잠시만 기다려주세요</p>
          </div>
        </div>

  </template>

    <div style="font-family: 'NanumBarunGothic'" class="noselect">
      <!-- 사이드바 (상:데스크톱, 하:모바일)-->
      <div class="d-none d-md-block d-lg-block d-xl-block">
        <div class="lftWrap">
          <a href="https://www.airportnoise.kr/anps/main" class="lftRow">
            <home-icon size="2.5x" class="sidebar-icon"></home-icon>
            <p class="sidebar-icon-title">메인</p>
          </a>
          <div class="lftRow" @click="viewMapList">
            <map-icon size="2.5x" class="sidebar-icon"></map-icon>
            <p class="sidebar-icon-title">지도</p>
          </div>
          <div class="lftRow" @click="viewInfList">
            <layers-icon size="2.5x" class="sidebar-icon"></layers-icon>
            <p class="sidebar-icon-title">레이어</p>
          </div>
          <div class="lftRow">
            <a v-b-modal.modal-1>
              <database-icon size="2.5x" class="sidebar-icon"></database-icon>
              <p class="sidebar-icon-title">통계</p>
            </a>
          </div>
          <div class="lftRow">
            <a @click="postOpen = !postOpen">
              <search-icon size="2.5x" class="sidebar-icon"></search-icon>
              <p class="sidebar-icon-title">주소검색</p>
            </a>
          </div>
          <div class="lftRow" style="border: none">
            <a @click="openRepalyModal">
              <airplay-icon size="2.25x" class="sidebar-icon"></airplay-icon>
              <p class="sidebar-icon-title">다시보기</p>
            </a>
          </div>
        </div>
        <div v-if="viewMap" class="subMap" @mouseleave="viewMapList">
          <div class="subMapWrap">
            <div
              style="margin: 15px"
              v-bind:key="tileLayers[value].layer"
              v-for="(id, value) in tileLayers"
            >
              <a @click="changeTileLayer(tileLayers[value].wms)">
                <b-img
                  class="navbar-map-image"
                  fluid
                  :src="tileLayers[value].img"
                  alt="Basic"
                />
                <span style="margin-left: 10px">{{
                  tileLayers[value].layer
                }}</span>
              </a>
            </div>
          </div>
        </div>
        <div v-if="viewInf" class="subInf" @mouseleave="viewInfList">
          <div class="subInfWrap">
            <div>
              <span style="margin-left: 10px ;margin-bottom :5px :">항공기위치</span>
              <a>
                <b-form-checkbox
                  v-model="isEnrouteTrackVisible"
                  class="custom-control-success navbar-checkbox"
                  switch
                  inline
                />
              </a>
            </div>
            <div>
              <span style="margin-left: 10px;margin-bottom :5px">소음등고선</span>
              <a>
                <b-form-checkbox
                  v-model="isNoiseLineVisible"
                  class="custom-control-success navbar-checkbox"
                  switch
                  inline
                />
              </a>
            </div>
            <div>
              <span style="margin-left: 10px">소음정보</span>
              <a>
                <b-form-checkbox
                  v-model="isNoisePointVisible"
                  class="custom-control-success navbar-checkbox"
                  switch
                  inline
                />
              </a>
            </div>
            <!--
            <div>
              <span style="margin-left: 10px">공간정보</span>
              <a>
                <b-form-checkbox
                  v-model="isWorldTerrainEnabled"
                  class="custom-control-success navbar-checkbox"
                  switch
                  inline
                />
              </a>
            </div>
            -->
          </div>
        </div>
      </div>

      <div class="d-block d-md-none d-lg-none d-xl-none">
        <div class="lftWrapMobile">
          <div class="lftRowMobile">
            <a @click="postOpen = !postOpen">
              <search-icon size="2.5x" class="sidebar-icon"></search-icon>
              <p class="sidebar-icon-title">주소검색</p>
            </a>
          </div>
          <div class="lftRowMobile" style="border: none">
            <a @click="openRepalyModal">
              <airplay-icon size="2.25x" class="sidebar-icon"></airplay-icon>
              <p class="sidebar-icon-title">다시보기</p>
            </a>
          </div>
          <div class="lftRowMobile" style="border: none">
            <a href="https://www.airportnoise.kr/anps/main" class="lftRowMobile">
            <home-icon size="2.5x" class="sidebar-icon"></home-icon>
            <p class="sidebar-icon-title">메인</p>
          </a>
          </div>
        </div>
      </div>

      <!-- 바로가기 (상:데스크톱, 하:모바일) -->
      <div v-if="airport==='KOR'" class="subApt d-block d-md-block d-lg-block d-xl-block">
        <p style="margin: 10px"><strong>바로가기</strong></p>
        <hr style="margin: 10px" />
        <p class="text-left" style="margin: 10px" @click="moveToEnroute()">
          전체공역
        </p>
        <div
          class="text-left"
          style="margin: 10px"
          @click="moveToAirport(value.id)"
          v-for="(value, key) in airports"
          v-bind:key="key"
        >
          {{ value.name }}
        </div>
      </div>

      <!-- 메인 -->
      <div :style="`height:` + windowHeight + `px`" class="map-viewer">
        <vc-viewer
          @LEFT_CLICK="getAddressFromPosition"
          :selectionIndicator="false"
          :infoBox="false"
          @ready="mapOnReady"
        >
          <vc-navigation
            style="margin-top: 100px"
            ref="navigation"
            :options="mapOptions"
          ></vc-navigation>
          <vc-layer-imagery></vc-layer-imagery>
        </vc-viewer>
      </div>

      <!-- 범례 (상:데스크톱, 하:모바일) -->
      <b-img
        v-if="weatherData[selectedAirportIata]"
        class="d-none d-md-block d-lg-block d-xl-block"
        style="
          position: absolute;
          top: 10px;
          right: 10px;
          border-radius: 5px;
          max-height: 175px;
        "
        fluid
        :src="require('./img/index.png')"
        alt="Basic"
      />

      <!-- 소음측정국정보 -->
      <b-modal
        ref="modal-2"
        centered
        header-bg-variant="dark"
        body-bg-variant="dark"
        footer-bg-variant="dark"
        hide-footer
        size="sm"
      >
        <div>
          <info v-bind:selectedPlace="selectedPlace"></info>
        </div>
      </b-modal>

      <!-- 소음측정국통계 -->
      <b-modal
        id="modal-1"
        centered
        size="xl"
        header-bg-variant="dark"
        body-bg-variant="dark"
        footer-bg-variant="dark"
        hide-footer
      >
        <div>
          <info-list v-bind:noiseSensorPoint="noiseSensorPoint"></info-list>
        </div>
      </b-modal>

      <!-- 리플레이 -->
      <b-modal
        ref="modal-3"
        centered
        header-bg-variant="dark"
        body-bg-variant="dark"
        footer-bg-variant="dark"
        hide-footer  
      >
      <!-- (상:데스크톱, 하:모바일) -->
        <div class="d-none d-md-block d-lg-block d-xl-block">
          <div style="font-family:'NanumBarunGothic'">
              <h2 style="margin-top:-20px; color:whitesmoke">날짜와 시간을 선택하세요</h2>
              <div style="margin-top:20px;">
                  <div style="display:inline-block;width:50%">
                      <b-calendar
                          block
                          v-model="selectedDate"
                          :min="minDate"
                          selected-variant = 'warning'
                          :max="maxDate"
                          nav-button-variant = 'white'
                          label-help=""
                          hide-header
                          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          locale="ko"
                          />
                  </div>            
                  <div style="position: absolute;left:53%;margin-top:-45%">
                      <p style="margin-left:20%;color:whitesmoke;font-size:15px">시간 (00:00)</p>
                      <div style="margin-top:-3%;margin-left:40%;padding-bottom:7.5px;padding-top:7.5px;border-radius:5px;background-color:white;width:75%;">
                          <timeselector ref="timeselectorRef1" style="width:86%" :h24="true" :displayFormat="'HH:mm'" :placeholder="' '" @selectedHour ="checktimeselector" @selectedMinute="checktimeselector" v-model="selectedTime"></timeselector>
                      </div>
                      <p style="margin-top:10%;margin-left:20%;color:whitesmoke;font-size:15px">구간 (00분)</p>
                      <div style="margin-top:-3%;margin-left:40%;width:75%;">
                          <b-dropdown
                              style="width:100%"
                              id="dropdown-4"
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              :text="duration+'분'"
                              variant="warning"
                              >
                              <b-dropdown-item @click="duration=10">10분</b-dropdown-item>
                              <b-dropdown-item @click="duration=20">20분</b-dropdown-item>
                              <b-dropdown-item @click="duration=30">30분</b-dropdown-item>
                              <b-dropdown-item @click="duration=60">60분</b-dropdown-item>
                          </b-dropdown>
                      </div>
                  </div>  
              </div>
          </div>
          <div
            class="mt-1 text-right"
            style="font-family:'NanumBarunGothic';color:whitesmoke;font-size:15px"
          >
              <span> 날짜/시간 : </span>
              <span v-if="selectedDate===null||formatedTime===null">없음</span>
              <span v-else>
                  {{selectedDate}} 
                  {{formatedTime}} 
                  <b-badge variant="warning" style="margin-left:3px" class="badge-glow">
                      {{duration}}분
                  </b-badge>
              </span>
              
          </div>
          <div class="mt-2 text-center">
              <b-button
                style="padding-left:3%;font-family:'NanumBarunGothic';width:97%"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="searchReplay()"
              >
                  검색
              </b-button>
          </div>
        </div>
        <div class="d-block d-md-none d-lg-none d-xl-none">
          <div style="font-family:'NanumBarunGothic'">
              <h2 style="margin-top:-20px; color:whitesmoke">날짜와 시간을 선택하세요</h2>
              <div style="margin-top:10px;">
                  <b-calendar
                      block
                      v-model="selectedDate"
                      :min="minDate"
                      :max="maxDate"
                      selected-variant = 'warning'
                      nav-button-variant = 'white'
                      label-help=""
                      hide-header
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      locale="ko"
                      />         
                  <div class="mt-1">
                      <p style="margin-left:3%;color:whitesmoke;font-size:15px">시간 (00:00)</p>
                      <div style="margin-left:3%;padding-bottom:7.5px;padding-top:7.5px;border-radius:5px;background-color:white;width:96%;">
                          <timeselector ref="timeselectorRef2" style="width:86%" :h24="true" :displayFormat="'HH:mm'" :placeholder="' '" @selectedHour ="checktimeselector" @selectedMinute="checktimeselector" v-model="selectedTime"></timeselector>
                      </div>
                      <p style="margin-top:5%;margin-left:3%;color:whitesmoke;font-size:15px">구간 (00분)</p>
                      <div style="margin-left:3%;width:96%;">
                          <b-dropdown
                              style="width:100%"
                              id="dropdown-4"
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              :text="duration+'분'"
                              variant="warning"
                              >
                              <b-dropdown-item @click="duration=10">10분</b-dropdown-item>
                              <b-dropdown-item @click="duration=20">20분</b-dropdown-item>
                              <b-dropdown-item @click="duration=30">30분</b-dropdown-item>
                              <b-dropdown-item @click="duration=60">60분</b-dropdown-item>
                              <b-dropdown-item @click="duration=90">90분</b-dropdown-item>
                          </b-dropdown>
                      </div>
                  </div>  
              </div>
          </div>
          <div
            class="mt-1 text-right"
            style="font-family:'NanumBarunGothic';color:whitesmoke;font-size:15px"
          >
              <span> 날짜/시간 : </span>
              <span v-if="selectedDate===null||formatedTime===null">없음</span>
              <span v-else>
                  {{selectedDate}} 
                  {{formatedTime}} 
                  <b-badge variant="warning" style="margin-left:3px" class="badge-glow">
                      {{duration}}분
                  </b-badge>
              </span>
          </div>
          <div class="mt-2 text-center">
              <b-button
                style="padding-left:3%;font-family:'NanumBarunGothic';width:97%"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="searchReplay()"
              >
                  검색 
              </b-button>
          </div>
        </div>

      </b-modal>
      
      <!-- 주소찾기 (상:데스크톱, 하:모바일) -->
      <div
        v-if="postOpen"
        class="form-box d-none d-md-block d-lg-block d-xl-block"
      >
        <x-icon
          @click="postOpen = !postOpen"
          size="1.75x"
          class="address-search-box-icon "
        ></x-icon>
       <vue-daum-postcode @complete="onAddressSearchComplete" />
      
      </div>
      <div
        v-if="postOpen"
        class="form-box-mobile d-block d-md-none d-lg-none d-xl-none"
      >
        <x-icon
          @click="postOpen = !postOpen"
          size="2x"
          class="address-search-box-icon "
        ></x-icon>
       <vue-daum-postcode @complete="onAddressSearchComplete" />
      </div>


      <!-- 주소 (상:데스크톱, 하:모바일) -->
      <div
        v-if="address"
        class="d-none d-md-none d-lg-block d-xl-block"
      >
        <div
          class="address-box text-left"
        >
          <div>
            <p
            style="margin-top: 10px; line-height: 3px; font-weight: bold"
            class="ml-2"
          >
            {{ address.address | maxAddressLength }}
          </p>
          <p style="line-height: 3px" v-if="address.jibunAddress" class="ml-2">
            ({{ address.jibunAddress | maxAddressLength }})
          </p>
          <p style="line-height: 3px" class="ml-2">
            {{ address.x }} / {{ address.y }}
          </p>
          <x-icon
            @click="closeAddressBox()"
            size="2x"
            class="address-box-icon"
          ></x-icon>
          </div>
        </div>
      </div>

      <div
        v-if="address"
        class="address-box-mobile d-block d-md-none d-lg-none d-xl-none"
      >
        <p
          style="margin-top: 10px; line-height: 3px; font-weight: bold"
          class="ml-2"
        >
          {{ address.address | maxAddressLengthMobile }}
        </p>
        <p style="line-height: 3px" v-if="address.jibunAddress" class="ml-2">
          ({{ address.jibunAddress | maxAddressLengthMobile }})
        </p>
        <p style="line-height: 3px" class="ml-2">
          {{ address.x }} / {{ address.y }}
        </p>
        <x-icon
          @click="closeAddressBox()"
          size="1.75x"
          style="margin-top:5px"
          class="address-box-icon"
        ></x-icon>
      </div>

      <!-- 기상/출도착 정보 -->
      <div
        class="d-none d-md-block d-lg-block d-xl-block info-box"
        v-if="selectedAirport !== ''"
      >
        <div class="mt-1 info-box-title-box">
          <!--
          <x-icon
            @click="moveToEnroute()"
            size="1.25x"
            class="weather-box-close-icon"
          ></x-icon>
          -->
          <span style="color: black; font-family:'NanumBarunGothic';font-size: 25px"
            ><strong>{{ selectedAirportTitle }}</strong></span
          >
          <span
            class="ml-1"
            v-if="mode.source === 'adsb'"
            style="
              font-size: 23px;
              padding-right: 5px;
              padding-left: 5px;
              background-color: orange;
              color: whitesmoke;
              border-radius: 5px;
            "
            >{{ selectedAirportIata }}</span
          >
          <span
            class="ml-1"
            v-else
            style="
              font-size: 23px;
              padding-right: 5px;
              padding-left: 5px;
              background-color: orange;
              color: whitesmoke;
              border-radius: 5px;
            "
            >{{ selectedAirportIata }}</span
          >
        </div>
        <div class="info-box-weather-box">
          <div class="text-center info-box-weather-box-icon mb-1">
            <p
              style="
                margin-top:15%;
                font-size: 30px;
                color: black;
              "
            >
              <strong v-if="weatherData[selectedAirportIata].desc">{{weatherData[selectedAirportIata].desc}}</strong>
            </p>
          </div>
          <div class="text-center info-box-weather-box-icon mb-1">
            <p
              style="
                margin-top: 15%;
                font-size: 40px;
                color: black;"
            >
              <strong>{{ weatherData[selectedAirportIata].temperature }}°C</strong>
              
            </p>
          </div>
        </div>
        <div class="info-box-weather-box">
          <div class="ml-2 info-box-weather-box-description">
            <p>
              <strong>풍향</strong>
              {{ weatherData[selectedAirportIata].direction }}°
            </p>
          </div>
          <div class="ml-2 info-box-weather-box-description">
            <p>
              <strong>풍속</strong> {{ weatherData[selectedAirportIata].speed }}kt
            </p>
          </div>
        </div>
        <div class="info-box-weather-box">
          <div class="ml-2 info-box-weather-box-description">
            <p>
              <strong>시정</strong>
              {{ weatherData[selectedAirportIata].visibility }}m
            </p>
          </div>
          <div class="ml-2 info-box-weather-box-description">
            <p>
              <strong>기압</strong> {{ weatherData[selectedAirportIata].qnh }}hPa
            </p>
          </div>
        </div>
        <p class="text-center info-box-weather-box-time">
          {{ weatherData[selectedAirportIata].issueTime | convertTime }}
        </p>
      </div>
      <div
        class="d-none d-md-block d-lg-block d-xl-block info-box2"
        v-if="selectedAirport !== ''"
      >
        <div style="margin-top: 5px">
          <span class="ml-1" style="color: black; font-size: 21px"
            ><strong> 항공편 출도착 정보</strong></span
          >
        </div>
        <div style="margin-top: 1px" class="text-right">
          <span
            @click="scheduleFocus = 'dep'"
            v-if="scheduleFocus === 'dep'"
            style="
              font-size: 13px;
              padding-right: 5px;
              padding-left: 5px;
              padding-top: 3px;
              padding-bottom: 3px;
              background-color: rgb(64, 72, 85, 1);
              color: whitesmoke;
              border-radius: 5px 0px 0px 5px;
            "
            >출발</span
          >
          <span
            @click="scheduleFocus = 'dep'"
            v-else-if="scheduleFocus === 'arr'"
            style="
              font-size: 13px;
              padding-right: 5px;
              padding-left: 5px;
              padding-top: 3px;
              padding-bottom: 3px;
              background-color: rgb(64, 72, 85, 0.4);
              color: whitesmoke;
              border-radius: 5px 0px 0px 5px;
            "
            >출발</span
          >
          <span
            @click="scheduleFocus = 'arr'"
            v-if="scheduleFocus === 'arr'"
            class=""
            style="
              margin-right: 3px;
              font-size: 13px;
              padding-right: 5px;
              padding-top: 3px;
              padding-bottom: 3px;
              padding-left: 5px;
              background-color: rgb(64, 72, 85, 1);
              color: whitesmoke;
              border-radius: 0px 5px 5px 0px;
            "
            >도착</span
          >
          <span
            @click="scheduleFocus = 'arr'"
            v-else-if="scheduleFocus === 'dep'"
            class=""
            style="
              margin-right: 3px;
              font-size: 13px;
              padding-right: 5px;
              padding-top: 3px;
              padding-bottom: 3px;
              padding-left: 5px;
              background-color: rgb(64, 72, 85, 0.4);
              color: whitesmoke;
              border-radius: 0px 5px 5px 0px;
            "
            >도착</span
          >
        </div>
        <div style="margin-top: 5px; max-height: 290px; overflow: hidden">
          <b-table
            v-if="isScheduleData"
            class="text-center"
            small
            sticky-header
            striped
            no-border-collapse
            :fields="scheduleTablefields[scheduleFocus]"
            :items="scheduleData[selectedAirportIata][scheduleFocus]"
            responsive="sm"
          />
        </div>
        <div style="margin-left:160px; width:135px; margin-top: 5px" >
          <b-input-group style="background-color:transparent" class="input-group-merge" size="sm">
            <feather-icon style="margin-top:6px;margin-right:10px;" size="1.25x" icon="SearchIcon" />
            <b-form-input v-model="depArrFilter" style="border-color:transparent; background-color:transparent" placeholder="검색 (항공사 등)" />
          </b-input-group>
        </div>
      </div>

      <!-- 리플레이 슬라이더 (상:데스크톱, 하:모바일) -->
      <div class="d-none d-md-block d-lg-block d-xl-block " v-if="isReplayMode">
            <div class="" style="z-index:9999;position:absolute; bottom: 80px; width:90%; left: 5% ;height:30px; background-color:whitesmoke;border-radius:5px 5px 5px 0px ">
                <chevrons-left-icon
                style="z-index:1000;position:absolute; top:0;left: 0.2% ;height:30px; color:black" 
                @click="previousReplay"
                ></chevrons-left-icon>
                <vue-slider
                  style="margin-top:6px;width:92%;margin-left:4%;z-index:9999"
                  v-model="convertedTimestampsReplayFlight[playIndexFlight]"
                  :data="convertedTimestampsReplayFlight"
                  :tooltip="'always'"
                  :dir ="'ltr'"
                  ref="slider1"
                  
                />
                <chevrons-right-icon
                style="z-index:1000;position:absolute; right: 0.4% ;top:0;height:30px; color:black"
                @click="nextReplay"
                ></chevrons-right-icon>
            </div>
      </div>
      <div class="d-block d-md-none d-lg-none d-xl-none " v-if="isReplayMode">
          <div class="" style="z-index:9999;position:absolute; bottom: 100px; width:90%; left: 5% ;height:30px; background-color:whitesmoke;border-radius:5px 5px 5px 5px ">
              <chevrons-left-icon
                style="z-index:1000;position:absolute; top:0;left: 0.2% ;height:30px; color:black" 
                @click="previousReplay"
              ></chevrons-left-icon>
              <vue-slider
                style="margin-top:6px;width:85%;margin-left:7.5%;z-index:9999"
                v-model="convertedTimestampsReplayFlight[playIndexFlight]"
                :data="convertedTimestampsReplayFlight"
                :tooltip="'always'"
                ref="slider2"
                :dir ="'ltr'"
              />
              <chevrons-right-icon
                style="z-index:1000;position:absolute; right: 0.8% ;top:0;height:30px; color:black"
                @click="nextReplay"
              ></chevrons-right-icon>
          </div>
      </div>
      <!-- 리플레이 (상:데스크톱, 하:모바일) -->
      <div class="d-none d-md-block d-lg-block d-xl-block " v-if="isReplayMode">
        <div class="demo-inline-spacing" style="z-index:1000;position:absolute; bottom: 45px; left:5%; height:35px; width:auto;background-color:whitesmoke;border-radius:0px 0px 5px 5px ">
            <div style="margin-top:0px;margin-left:10px;height:25px; width:25px;background-color:rgb(64,72,85);border-radius:50%">
                <play-icon @click="startReplay()" v-if="!isReplayPlayOn" size="1.25x" style="margin-left:5px;margin-top:3px;color:whitesmoke"></play-icon>
                <pause-icon  @click="stopReplay()" v-else size="1.25x" style="margin-left:4px;margin-top:2px;color:whitesmoke"></pause-icon>
            </div>
            <div v-if="replayData.flight.length>=1" style="margin-left:10px;margin-top:2px;margin-right:25px">
                <span style="color:black;font-size:22px">{{replayData.flight[playIndexFlight]['_time']|filterTime}}</span>
            </div>

            <div class="" style="z-index:1000; margin-top: 0px; margin-left:10px;" >
                <b-badge
                @click ="changeReplaySpeed()"
                variant="warning"
                class="badge-glow"
                >
                {{replaySpeed}}배속
                </b-badge>
            </div>

            <div style="margin-top:0px;margin-left:10px; margin-right:10px;height:25px; width:25px;background-color:rgb(64,72,85);border-radius:50%">
                <log-out-icon @click="quitReplay()" v-if="isReplayMode" size="1.25x" style="margin-left:6px;margin-top:2px;color:whitesmoke"></log-out-icon>
            </div>
          </div>
      </div>

      <div class="d-block d-md-none d-lg-none d-xl-none text-center" v-if="isReplayMode">
        <div class="demo-inline-spacing" style="z-index:1000;position:absolute; bottom: 170px;margin-left:10px; height:40px;width:auto;background-color:transparent;">
            <div style="margin-top:0px;margin-left:20px;height:40px; width:40px;background-color:white;border-radius:50%">
                <play-icon @click="startReplay()" v-if="!isReplayPlayOn" size="1.75x" style="margin-top:8px;color:black"></play-icon>
                <pause-icon  @click="stopReplay()" v-else size="1.75x" style="margin-top:8px;color:black"></pause-icon>
            </div>
            <div style="margin-top:4px;margin-left:5px; height:40px; width:40px;background-color:white;border-radius:50%">
                <log-out-icon @click="quitReplay()" v-if="isReplayMode" size="1.75x" style="margin-top:8px;color:black"></log-out-icon>
            </div>
            <div class="" style="z-index:1000; margin-top: 4px;" >
                <b-badge
                style="background-color: white;color:black"
                @click ="changeReplaySpeed()"
                class="badge-glow"
                >
                {{replaySpeed}}배속
                </b-badge>
            </div>

          </div>
      </div>
    </div>
  </b-overlay>

</template>

<script>
//Default
import { 
  BIcon,
  BInputGroup,
  BFormInput,
  BTable,
  BModal,
  VBModal,
  BCarousel,
  BCarouselSlide,
  VBTooltip,
  BButton,
  BBadge,
  VBToggle,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BImg,
  BSpinner,
  BCalendar,
  BOverlay,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
//Utils
const CronJob = require("cron").CronJob
const { uuid } = require("uuidv4")
const { XMLParser, XMLBuilder, XMLValidator} = require("fast-xml-parser")
const parser = new XMLParser()
import Timeselector from 'vue-timeselector'
import axios from "axios"
const geocoder = new daum.maps.services.Geocoder()

//Cesium
import "vue-cesium/lib/vc-navigation.css"
import 'vue-slider-component/theme/default.css'
//Icon
import {
  XIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
  HomeIcon,
  PlayIcon,
  LogOutIcon,
  PauseIcon,
  SearchIcon,
  LayersIcon,
  MapIcon,
  DatabaseIcon,
  AirplayIcon,
} from "vue-feather-icons"

//JS
import * as trackUtils from "./js/track.js"
import * as mapUtils from "./js/map.js"
import * as noiseUtils from "./js/noise.js"

//Config
import * as mapConfig from "./config/map.js"
import { url } from "./config/url.js"
import { mode } from "./config/mode.js"

//Data
import * as airportDataIata from "./data/airportsIata.js"
import * as airportData from "./data/airports.js"
import airportIcon from "./img/airport.png"

//Components
import Info from "./components/Info.vue"
import InfoList from "./components/InfoList.vue"
import * as utils from './js/utils'
//Api
import { VueDaumPostcode } from "vue-daum-postcode" 

export default {
  props: { 
    airport: String,
  },
  components: {
    BModal,
    Info,
    BDropdown,
    BDropdownItem, 
    InfoList,
    BOverlay,
    BSpinner,
    BImg,
    BFormCheckbox,
    BCalendar,
    BCarousel,
    BCarouselSlide,
    LogOutIcon,
    BInputGroup,
    BFormInput,
    BIcon,
    BButton,
    BBadge,
    BTable,
    PlayIcon,
    ChevronsLeftIcon,
    ChevronsRightIcon,
    PauseIcon,
    Timeselector,
    XIcon,
    SearchIcon,
    HomeIcon,
    LayersIcon,
    MapIcon,
    AirplayIcon,
    DatabaseIcon,
    VueDaumPostcode,
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setDate(minDate.getDate()-90)
    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {
      //Default
      stat: null,
      mode: mode,
      currentDefaultLayer: "Sat",
      currentAirport: null,
      isloading: true,
      isInit : true, 
      currentAirportPos: null,
      view: "Enroute",
      scheduleFocus: "dep",
      depArrFilter : "",
      time: null,
      localTime: null,
      slide: 0,
      selectedYear: null,
      yearOption: [],
      airportOption: ["GMP", "CJU", "PUS"],
      selectedAirport: "",
      selectedAirportTitle : "",
      selectedAirportIata: "",
      selectedAirportIcao: "",

      //Noise Line 
      prefetchYear : null, 
      noiseLineRange : [75, 80, 85, 90, 95],
      noiseLine : {
        "75" : null,
        "80" : null,
        "85" : null,
        "90" : null,
        "95" : null,
      },

      //Toggler
      isNoisePointVisible: true,
      isNoiseLineVisible: true,
      isWorldTerrainEnabled: true,
      isEnrouteTrackVisible: true,
      trackHistory: [],
      selectedPlace: null,
      isScheduleData: false,
      //WatchDog Process
      watchDogProcess: null,
      watchDogProcessTrigger: true,
      watchDogCronInterval: "*/5 * * * * *",

      //WatchDog Process
      trackProcess: null,
      trackProcessTrigger: true,
      trackProcessCronInterval: "*/2 * * * * *",
      trackData: [],

      //Noise Process
      noiseProcess: null,
      noiseProcessTrigger: true,
      noiseProcessCronInterval: "*/2 * * * * *",
      noiseData: [],
      noiseSensorPoint : null, 
      //Weather Process
      weatherProcess: null,
      weatherProcessTrigger: true,
      weatherProcessCronInterval: "*/5 * * * *",
      weatherData: {},

      //Schedule Process
      scheduleProcess: null,
      scheduleProcessTrigger: true,
      scheduleProcessCronInterval: "*/5 * * * *",
      originalScheduleData : {}, 
      scheduleData: {},
      scheduleTablefields: {
        dep: [
          { key: "airlineKorean", label: "항공사" },
          { key: "airFln", label: "편명" },
          { key: "arrivedKor", label: "도착지" },
          { key: "std", label: "시간" },
        ],
        arr: [
          { key: "airlineKorean", label: "항공사" },
          { key: "airFln", label: "편명" },
          { key: "boardingKor", label: "출발지" },
          { key: "std", label: "시간" },
        ],
      },

      //PlaceHolder and ToolTip
      tooltipDelay: { show: 500, hide: 500 },

      //Map Instance
      cesiumInstance: null,

      wbtitle: null,
      wbarp: null,
      wbno: null,
      wbaddr: null,
      wbgeo: null,
      info_arr: [],

      //Map Default Options
      mapOptions: mapConfig.defaultMapOptions,

      //Map Layers
      tileLayers: mapConfig.tileLayers,

      //Others
      airports: airportData.location,
      airportIcon: airportIcon,
      viewMap: false,
      viewInf: false,
      viewApt: false,

      //Address,
      address: null,
      domSize: 5200,
      postOpen: false,
      mouseLat: null,
      mouseLng: null,

      //Replay
      isReplayMode : false,
      isReplayPlayOn : false,
      draggingIndex : 0,
      replaySpeed : 8,
      replayRepeat : true,
      replayStartTime :null, 
      selectedDate : null, 
      selectedTime : null, 
      formatedTime : null, 
      minDate : minDate,
      maxDate : maxDate, 
      ancTrigger : true, 
      ancTime : 4500,
      duration : 20,
      replayData : null, 
      convertedTimestampsReplayFlight: [],
      convertedTimestampsReplayNoise :[],
      timestampsReplayFlight: [],
      timestampsReplayNoise: [],
      timestampsReplaySchedule: [],
      timestampsReplayWeather : [],
      intervalReplayFlight: [],
      intervalReplayNoise : [],
      intervalReplayWeather: [],
      intervalReplaySchedule : [],
      playIndexFlight : 0,
      playIndexNoise : 0,
      playIndexSchedule : 0,
      playIndexWeather : 0,
      intervalReplayWeatherInstance : null,
      intervalReplayScheduleInstance : null,
      intervalReplayFlightInstance : null,
      intervalReplayNoiseInstance : null,

      parseOptions: {
        attributeNamePrefix : "",
        attrNodeName: false, //default is 'false'
        textNodeName : "#text",
        ignoreAttributes : false,
        ignoreNameSpace : true,
        allowBooleanAttributes : false,
        parseNodeValue : true,
        parseAttributeValue : false,
        trimValues: true,
        cdataTagName: "__cdata", //default is 'false'
        cdataPositionChar: "\\c",
        localeRange: "", //To support non english character in tag/attribute values.
        parseTrueNumberOnly: false,
        attrValueProcessor: (val, attrName) => he.decode(val, {isAttributeValue: false}),//default is a=>a
        tagValueProcessor : (val, tagName) => he.decode(val), //default is a=>a
        stopNodes: ["parse-me-as-string"]
      }
    }
  },

  created() {
    this.stat = this
  },
  mounted() {
    this.stat.lastWatchDogTimeStamp = new Date().getTime()
    this.stat.selectedYear = new Date().getFullYear()
    this.stat.prefetchYear =  new Date().getFullYear()
    for (let i = 0; i < 2; i++) {
      this.stat.yearOption.push(this.stat.selectedYear - i)
      
    }

    this._airport = this.airport.toUpperCase()
    //this.stat.$refs["modal-anc"].show()
    setTimeout(()=>{
      this.stat.ancTrigger = false
    },this.stat.ancTime)

    this.stat.preFetch()
  },

  watch: {
    depArrFilter : function(newValue, oldValue){
      if(newValue===''){
        this.scheduleData = JSON.parse(JSON.stringify(this.originalScheduleData))
      } else { 
        let obj = JSON.parse(JSON.stringify(this.originalScheduleData))
        for(let i in this.airportOption){
          obj[this.airportOption[i]].dep = []
          obj[this.airportOption[i]].arr = []
          for(let j in this.originalScheduleData[this.airportOption[i]].dep){
            if(this.originalScheduleData[this.airportOption[i]].dep[j].airFln.includes(newValue)){
                obj[this.airportOption[i]].dep.push((this.originalScheduleData[this.airportOption[i]].dep[j]))
            } else if(this.originalScheduleData[this.airportOption[i]].dep[j].airlineEnglish.includes(newValue)){
                obj[this.airportOption[i]].dep.push((this.originalScheduleData[this.airportOption[i]].dep[j]))
            }else if(this.originalScheduleData[this.airportOption[i]].dep[j].airlineKorean.includes(newValue)){
                obj[this.airportOption[i]].dep.push((this.originalScheduleData[this.airportOption[i]].dep[j]))
            }
          }
          for(let j in this.originalScheduleData[this.airportOption[i]].arr){
            if(this.originalScheduleData[this.airportOption[i]].arr[j].airFln.includes(newValue)){
                obj[this.airportOption[i]].arr.push((this.originalScheduleData[this.airportOption[i]].arr[j]))
            } else if(this.originalScheduleData[this.airportOption[i]].arr[j].airlineEnglish.includes(newValue)){
                obj[this.airportOption[i]].arr.push((this.originalScheduleData[this.airportOption[i]].arr[j]))
            }else if(this.originalScheduleData[this.airportOption[i]].arr[j].airlineKorean.includes(newValue)){
                obj[this.airportOption[i]].arr.push((this.originalScheduleData[this.airportOption[i]].arr[j]))
            }
          }

        }
        this.scheduleData = JSON.parse(JSON.stringify(obj))
      }
    },  
    isEnrouteTrackVisible: function (newValue, oldValue) {
      if (newValue) {
        mapUtils.toogleEntity(this.stat, "track", true)
        mapUtils.toogleEntity(this.stat, "trackHistory", true)
      } else {
        mapUtils.toogleEntity(this.stat, "track", false)
        mapUtils.toogleEntity(this.stat, "trackHistory", false)
      }
    },
    selectedTime : function(newValue, oldValue){    
        let date = new Date(newValue)
        let min = date.getMinutes().toString()
        if(min.length===1){
            min = '0' + min
        }
        let hr = date.getHours().toString()
        if(hr.length===1){
            hr = '0' + hr
        }
        this.stat.formatedTime = hr+':'+min
    },
    isNoisePointVisible: function (newValue, oldValue) {
      if (newValue) {
        mapUtils.toogleNoisePoint(this.stat, true)
      } else {
        mapUtils.toogleNoisePoint(this.stat, false)
      }
    },

    isNoiseLineVisible: function (newValue, oldValue) {
      if (newValue) {
        mapUtils.toogleNoiseLine(this.stat, true)
      } else {
        mapUtils.toogleNoiseLine(this.stat, false)
      }
    },

    isWorldTerrainEnabled: function (newValue, oldValue) {
      if (newValue) {
        for (let i = 1; i <= 12; i++) {
          this.stat.cesiumInstance.viewer.scene.primitives._primitives[
            i
          ].show = true
        }
      } else {
        for (let i = 1; i <= 12; i++) {
          this.stat.cesiumInstance.viewer.scene.primitives._primitives[
            i
          ].show = false
        }
      }
    },
    replaySpeed:  function(newValue, oldValue){
        console.log('replay mode in')
        let stat = this.stat 

        for(let i in stat.intervalReplayFlight){
            stat.intervalReplayFlight[i] = stat.intervalReplayFlight[i]*oldValue
            stat.intervalReplayFlight[i] = stat.intervalReplayFlight[i]/newValue        
        }
        for(let i in stat.intervalReplayNoise){
            stat.intervalReplayNoise[i] = stat.intervalReplayNoise[i]*oldValue
            stat.intervalReplayNoise[i] = stat.intervalReplayNoise[i]/newValue        
        }
        for(let i in stat.intervalReplayWeather){
            stat.intervalReplayWeather[i] = stat.intervalReplayWeather[i]*oldValue
            stat.intervalReplayWeather[i] = stat.intervalReplayWeather[i]/newValue        
        }
        for(let i in stat.intervalReplaySchedule){
            stat.intervalReplaySchedule[i] = stat.intervalReplaySchedule[i]*oldValue
            stat.intervalReplaySchedule[i] = stat.intervalReplaySchedule[i]/newValue        
        }
        if(stat.isReplayPlayOn) {
            stat.stopReplay()
            stat.startReplay()
        }
    },
    replayStartTime: function(newValue, oldValue){
      if(newValue===null) return
      if(newValue){
          let stat = this.stat
          stat.isloading = true
          stat.depArrFilter = ''
          if(stat.replayData){
              stat.clearReplay()
          }
          let airport = null 
          if(stat.currentAirport="RKSS"){
            airport = "gmp"
          } else if (stat.currentAirport="RKPC"){
            airport = "cju"
          } else if (stat.currentAirport="RKPK"){
            airport = "pus"
          }
          axios.get(url[mode.where].replay + newValue +"/" + stat.duration*60 +"/" + airport).then(response => {
            this.prepareReplay()
            stat.replayData = response.data
            for(let i = 0; i < response.data.flight.length; i++){
                stat.convertedTimestampsReplayFlight.push(new Date(response.data.flight[i]['_time']).toLocaleTimeString())
                let obj = {
                  time : new Date(response.data.flight[i]['_time']).toLocaleTimeString(), 
                  timestamp: Math.floor(new Date(response.data.flight[i]['_time']).getTime()/1000)
                }
                stat.timestampsReplayFlight.push(obj)
            }
            for(let i = 1 ; i < response.data.flight.length; i++){
                let prevTime = new Date(response.data.flight[i-1]['_time']).getTime()
                let time = new Date(response.data.flight[i]['_time']).getTime()
                let interval = time - prevTime 
                stat.intervalReplayFlight.push(interval/stat.replaySpeed)
            }

            for(let i = 0; i < response.data.noise.length; i++){
                stat.convertedTimestampsReplayNoise.push(new Date(response.data.noise[i]['_time']).toLocaleTimeString())
                let obj = {
                  time : new Date(response.data.noise[i]['_time']).toLocaleTimeString(), 
                  timestamp: Math.floor(new Date(response.data.noise[i]['_time']).getTime()/1000)
                }
                stat.timestampsReplayNoise.push(obj)
            }

            for(let i = 1 ; i < response.data.noise.length; i++){
                let prevTime = new Date(response.data.noise[i-1]['_time']).getTime()
                let time = new Date(response.data.noise[i]['_time']).getTime()
                let interval = time - prevTime 
                stat.intervalReplayNoise.push(interval/stat.replaySpeed)
            }
            if(response.data.weather.length>1){

            } else {
                for(let i = 1 ; i < response.data.weather.length; i++){
                    let prevTime = new Date(response.data.weather[i-1]['_time']).getTime()
                    let time = new Date(response.data.weather[i]['_time']).getTime()
                    let interval = time - prevTime 
                    stat.intervalReplayWeather.push(interval/stat.replaySpeed)
                }
            }
            if(response.data.schedule.length>1){

            } else {
                for(let i = 1 ; i < response.data.schedule.length; i++){
                    let prevTime = new Date(response.data.schedule[i-1]['_time']).getTime()
                    let time = new Date(response.data.schedule[i]['_time']).getTime()
                    let interval = time - prevTime 
                    stat.intervalReplaySchedule.push(interval/stat.replaySpeed)
                }
            }

            stat.startReplay()
            stat.isloading = false
            stat.isReplayMode = true
            stat.isReplayPlayOn = true
          }).catch (e => {
            stat.isloading = false
          })
      }
    },
  },
  filters: {
    filterTime : function(val){
        let newVal = ""
        newVal =  newVal + new Date(val).toLocaleDateString()
        newVal = newVal + " " + new Date(val).toLocaleTimeString()
        return newVal
    },
    maxAddressLength(val) {
      if (val.length >= 28) {
        let newVal = val.substring(0, 27) + "..."
        return newVal
      } else {
        return val
      }
    },
    maxAddressLengthMobile(val) {
      if (val.length >= 20) {
        let newVal = val.substring(0, 19) + "..."
        return newVal
      } else {
        return val
      }
    },
    convertTime(val) {
      const date = new Date(val)
      return date.toLocaleString()
    },
  },
  methods: {
    noiseLineQuery(airport, range, year) {
    return `<wfs:GetFeature service="WFS" version="1.1.0">
        <wfs:Query typeName="TL_NS_CTRLN" srsName="EPSG:4326">
        <ogc:SrsName>EPSG:4326</ogc:SrsName>
        <ogc:Filter>
            <ogc:And>
                <ogc:PropertyIsEqualTo>
                <ogc:PropertyName>ARP_SE</ogc:PropertyName>
                <ogc:Literal>` + airport + `</ogc:Literal>
                </ogc:PropertyIsEqualTo>
                <ogc:PropertyIsEqualTo>
                <ogc:PropertyName>YEAR</ogc:PropertyName>
                <ogc:Literal>` + year + `</ogc:Literal>
                </ogc:PropertyIsEqualTo>
                <ogc:PropertyIsEqualTo>
                <ogc:PropertyName>WECPNL</ogc:PropertyName>
                <ogc:Literal>` + range + `</ogc:Literal>
                </ogc:PropertyIsEqualTo>
            </ogc:And>
        </ogc:Filter>
        </wfs:Query>
     </wfs:GetFeature>`
    },
    preFetch(){
      let year = this.stat.prefetchYear
      for (let i in this.noiseLineRange){
        this.getNoiseLine(this.airport.toUpperCase(), this.noiseLineRange[i], year)
      }

      this.getNoisePosition()

      setTimeout(()=>{
        mapUtils.loadNoiseLine(this.stat)
        mapUtils.loadNoiseSensorPoint(this.stat)
      },2000)
    },
    getNoisePosition(){
      axios
        .get(url[mode.where].noisePosition)
        .then(response => {
          let jsonStr = JSON.stringify(parser.parse(response.data, this.parseOptions))
          jsonStr = jsonStr.replaceAll("noisedb:","")
          jsonStr = jsonStr.replaceAll("wfs:","")
          jsonStr = jsonStr.replaceAll("gml:","")
          let json = JSON.parse(jsonStr)
          this.stat.noiseSensorPoint = json
          

        })
        .catch(err => {
          console.log("Failed to Receive Noise Position", err)
        })
    },
    getNoiseLine(airport, range, year){
      let query = this.noiseLineQuery(this.airport.toUpperCase(), range, year )
      axios
        .post(url[mode.where].noiseGis, query)
        .then(response => {
          if(response.data.toString().length<800){
            this.getNoiseLine(airport, range, year-1)
          } else {
            this.stat.noiseLine[range] = response.data
          }
        })
        .catch(err => {
          console.log("Failed to Receive NoiseLine", err)
        })
    }, 
    draggingSlider: function(value,index){
      for(let i in this.timestampsReplayFlight){
        if(this.timestampsReplayFlight[i].time == value) {
          this.draggingIndex = i
        }
      }
    }, 
    replaySlideMove : function(){
      if(this.timestampsReplayFlight.length>=10){
        this.stopReplay()
        this.clearReplayForDragging()

        this.playIndexFlight = this.draggingIndex
        this.draggingIndex = 0 

        let j = 0 
        for(let i in this.timestampsReplayNoise){
          if(this.timestampsReplayFlight[this.draggingIndex].timestamp > this.timestampsReplayNoise[i].timestamp){
            j = i 
          }
        }
        this.playIndexNoise = j

        this.startReplay()
      }
    },  
    previousReplay : function(){
      this.replayStartTime = this.replayStartTime - this.stat.duration*60
    },
    nextReplay : function(){
      this.replayStartTime = this.replayStartTime + this.stat.duration*60
    },
    closeAncModal : function(){
          this.isloading = false
          this.isInit = false
    },
    prepareReplay : function(){
        let stat = this.stat
        let trackEntities = []
        let noiseEntities = []
        let arr = []
        for (let i in stat.cesiumInstance.viewer.entities.values) {
          if (
            stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
            "addressDistancePolyline"
          ) {
            arr.push(stat.cesiumInstance.viewer.entities.values[i].id)
          }
          if (
            stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
            "addressDistanceLabel"
          ) {
            arr.push(stat.cesiumInstance.viewer.entities.values[i].id)
          }
        }
        for (let i in arr) {
          stat.cesiumInstance.viewer.entities.removeById(arr[i])
        }
 //       this.stat.weatherData = {}
 //       this.stat.scheduleData = {}
        this.stat.trackData = []
        for(let i in stat.cesiumInstance.viewer.entities.values){
            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
                trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }
            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='track'){
                trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }

            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='noiseSensorPoint'){
                noiseEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }
        }
        for (let i in trackEntities){
            stat.cesiumInstance.viewer.entities.remove(trackEntities[i])
        }
        for (let i in noiseEntities){
            noiseEntities[i].label.text['_value'] = ''
        }
    },

    stopReplay : function(){
        let stat = this.stat
        stat.isReplayPlayOn = false
        clearInterval(stat.intervalReplayFlightInstance)
        clearInterval(stat.intervalReplayNoiseInstance)     
        clearInterval(stat.intervalReplayWeatherInstance)
        clearInterval(stat.intervalReplayScheduleInstance)              
    },

    startReplay : function(){
        let stat = this.stat
        stat.isReplayPlayOn = true
        if(stat.replayData.noise.length>0){
          stat.intervalReplayNoiseInstance = setInterval(()=>{
              let stat = this.stat
              let noises = JSON.parse(stat.replayData.noise[stat.playIndexNoise]['_value'])
              noiseUtils.updateNoise(stat, noises)
              if (stat.intervalReplayNoise.length===stat.playIndexNoise){
                  stat.playIndexNoise = 0
              } else {
                  stat.playIndexNoise ++ 
              }
              
          }, stat.intervalReplayNoise[stat.playIndexNoise])
        }

        if(stat.replayData.flight.length>0){
          stat.intervalReplayFlightInstance = setInterval(()=>{
            let stat = this.stat
            if (mode.source === "adsb") {
                let flights = JSON.parse(stat.replayData.flight[stat.playIndexFlight]['_value'])
                for (let i in flights) {
                  stat.extractTrack(stat, flights[i], "adsb")
                }
            } else {
                let flights = JSON.parse(stat.replayData.flight[stat.playIndexFlight]['_value'])
                for (let i in flights) {
                    if (Array.isArray(flights[i])) {
                    if (flights[i][4] >= 100) {
                        stat.extractTrack(stat, flights[i], "flight-radar")
                    }
                    }
                }
            }

            if (stat.intervalReplayFlight.length===stat.playIndexFlight){
                let trackEntities = []
                let noiseEntities = []
                this.stat.trackData = []
                for(let i in stat.cesiumInstance.viewer.entities.values){
                    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
                        trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
                    }
                    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='track'){
                        trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
                    }

                    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='noiseSensorPoint'){
                        noiseEntities.push(stat.cesiumInstance.viewer.entities.values[i])
                    }
                }
                for (let i in trackEntities){
                    stat.cesiumInstance.viewer.entities.remove(trackEntities[i])
                }
                stat.playIndexFlight = 0
            } else {
                stat.playIndexFlight ++ 
            }
              
          }, stat.intervalReplayFlight[stat.playIndexFlight])  

        }

        if(stat.replayData.weather.length>0){
          if(stat.replayData.weather.length===1){
            stat.weatherData = JSON.parse(stat.replayData.weather[0]['_value'])
          } else { 
            stat.intervalReplayWeatherInstance = setInterval(()=>{
                let stat = this.stat
                let weather = JSON.parse(stat.replayData.weather[stat.playIndexWeather]['_value'])
                stat.weatherData = weather
                if (stat.intervalReplayWeather.length===stat.playIndexWeather){
                    stat.playIndexWeather = 0
                } else {
                    stat.playIndexWeather ++ 
                }
            }, stat.intervalReplayWeather[stat.playIndexWeather])  
          }
        }
        if(stat.replayData.schedule.length>0){
          if(stat.replayData.schedule.length===1){
            stat.originalScheduleData = JSON.parse(stat.replayData.schedule[0]['_value'])
            stat.scheduleData = JSON.parse(stat.replayData.schedule[0]['_value'])
          } else { 
            stat.intervalReplayScheduleInstance = setInterval(()=>{
                let stat = this.stat
                stat.originalScheduleData = JSON.parse(stat.replayData.schedule[stat.playIndexSchedule]['_value'])
                stat.scheduleData = JSON.parse(stat.replayData.schedule[stat.playIndexSchedule]['_value'])
                if (stat.intervalReplaySchedule.length===stat.playIndexSchedule){
                    stat.playIndexSchedule = 0
                } else {
                    stat.playIndexSchedule ++ 
                }
            }, stat.intervalReplaySchedule[stat.playIndexSchedule])  
          }
        }
    },
    clearReplayForDragging : function(){
      let stat = this.stat
      let trackEntities = []
      let noiseEntities = []
      let distanceEntities = []

      for(let i in stat.cesiumInstance.viewer.entities.values){
          if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
              trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
          }

          if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='track'){
              trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
          }

          if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='noiseSensorPoint'){
              noiseEntities.push(stat.cesiumInstance.viewer.entities.values[i])
          }

          if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistancePolyline'){
              distanceEntities.push(stat.cesiumInstance.viewer.entities.values[i])
          }

          if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistanceLabel'){
              distanceEntities.push(stat.cesiumInstance.viewer.entities.values[i])
          }
        }

        for (let i in trackEntities){
            stat.cesiumInstance.viewer.entities.remove(trackEntities[i])
        }
        for (let i in distanceEntities){
            stat.cesiumInstance.viewer.entities.remove(distanceEntities[i])
        }
        
        for (let i in noiseEntities){
            noiseEntities[i].label.text['_value'] = ''
        }
    }, 
    clearReplay : function(){
        let stat = this.stat
        clearInterval(stat.intervalReplayFlightInstance)
        clearInterval(stat.intervalReplayNoiseInstance)     
        clearInterval(stat.intervalReplayWeatherInstance)
        clearInterval(stat.intervalReplayScheduleInstance)

        stat.intervalReplayFlight = []
        stat.intervalReplayNoise = []
        stat.intervalReplayWeather = []
        stat.intervalReplaySchedule = []
        stat.timestampsReplayFlight = []
        stat.convertedTimestampsReplayFlight = []
        stat.isReplayMode = false
        stat.isReplayPlayOn = false

        stat.playIndexFlight = 0 
        stat.playIndexNoise = 0 
        stat.playIndexSchedule = 0 
        stat.playIndexWeather = 0     

        let trackEntities = []
        let noiseEntities = []
        let distanceEntities = []

        for(let i in stat.cesiumInstance.viewer.entities.values){
            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
                trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }

            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='track'){
                trackEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }

            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='noiseSensorPoint'){
                noiseEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }

            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistancePolyline'){
                distanceEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }

            if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistanceLabel'){
                distanceEntities.push(stat.cesiumInstance.viewer.entities.values[i])
            }
        }

        for (let i in trackEntities){
            stat.cesiumInstance.viewer.entities.remove(trackEntities[i])
        }
        for (let i in distanceEntities){
            stat.cesiumInstance.viewer.entities.remove(distanceEntities[i])
        }

        for (let i in noiseEntities){
            noiseEntities[i].label.text['_value'] = ''
        }
    }, 

    searchReplay : function(){
        if(!this.stat.selectedDate) return
        if(!this.stat.formatedTime) return 
        let time = this.stat.selectedDate+"T"+this.stat.formatedTime+"+09:00"
        let date = new Date(time.toString())
        this.stat.replayStartTime = Math.floor(date.getTime() / 1000)
        this.$refs['modal-3'].hide()
    }, 

    quitReplay : function (){
        this.clearReplay()
        this.stat.replayStartTime = null
        this.stat.replayData = null 
        
//        this.stat.weatherData = { }
//        this.stat.scheduleData = { }
        this.stat.trackData = []
        axios
        .get(url[mode.where].weather)
        .then(response => {
          this.stat.weatherData = response.data
        })
        .catch(err => {
          console.log("Failed to Receive Weather", err)
        })
        axios
        .get(url[mode.where].schedule)
        .then(response => {
          this.stat.originalScheduleData = JSON.parse(JSON.stringify(response.data))
          this.stat.scheduleData = JSON.parse(JSON.stringify(response.data))
        })
        .catch(err => {
          console.log("Failed to Receive Schedule", err)
        })
    },

    changeReplaySpeed : function(){
        let val = this.stat.replaySpeed
        if(val>=16){
            val = 1
        } else {
            val = val*2
        }
        this.stat.replaySpeed = val  
    },

    getAddressFromPosition: function () {
      if(this.windowHeight>this.windowWidth) return
      const posSearch = (lat, lng) => {
        return new Promise((resolve, reject) => {
          geocoder.coord2Address(lng, lat, function (result, status) {
            if (status === kakao.maps.services.Status.OK) {
              resolve(result[0])
            } else {
              reject(-1)
            }
          })
        })
      }
      ;(async () => {
        try {
          const result = await posSearch(this.stat.mouseLat, this.stat.mouseLng)
          if (result !== -1) {
            this.stat.address = {}

            if (result.road_address) {
              this.stat.address.address = result.road_address.address_name
            } else {
              this.stat.address.address = "도로명 주소 없음"
            }

            if (result.address) {
              this.stat.address.jibunAddress = result.address.address_name
            } else {
              this.stat.address.jibunAddress = "지번 주소 없음"
            }

            this.stat.address.x = this.stat.mouseLng
            this.stat.address.y = this.stat.mouseLat
            this.moveToAddress2(this.stat.address.x, this.stat.address.y)
          }
        } catch (e) {
          this.stat.address = null
        }
      })()
    },

    onAddressSearchComplete: function (result) { 
      const addressSearch = address => {
        return new Promise((resolve, reject) => {
          geocoder.addressSearch(address, function (result, status) {
            if (status === kakao.maps.services.Status.OK) {
              resolve(result[0])
            } else {
              reject(-1)
            }
          })
        })
      }

      ;(async () => {
        try {
          const coords = await addressSearch(result.address)
          if (coords !== -1) {
            this.stat.address = result
            this.stat.address.x = coords.x
            this.stat.address.y = coords.y
            this.stat.postOpen = false
            this.moveToAddress2(this.stat.address.x, this.stat.address.y)
          }
        } catch (e) {
          this.stat.address = null
        }
      })()
    },

    closeAddressBox: function () {
      let entity1 = null
      let entity2 = null

      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressVerticalPolyline"
        ) {
          entity1 = this.stat.cesiumInstance.viewer.entities.values[i]
        }
      }

      if (entity1) this.stat.cesiumInstance.viewer.entities.remove(entity1)
      
      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDom"
        ) {
          entity2 = this.stat.cesiumInstance.viewer.entities.values[i]
        }
      }

      if (entity2) this.stat.cesiumInstance.viewer.entities.remove(entity2)
      
      let arr = []
      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDistancePolyline"
        ) {
          arr.push(this.stat.cesiumInstance.viewer.entities.values[i].id)
        }
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDistanceLabel"
        ) {
          arr.push(this.stat.cesiumInstance.viewer.entities.values[i].id)
        }
      }

      for (let i in arr) {
        this.stat.cesiumInstance.viewer.entities.removeById(arr[i])
      }

      this.stat.address = null
    },

    getUUID: function () {
      return uuid()
    },

    mapOnReady: function (cesiumInstance) {
      this.stat.cesiumInstance = cesiumInstance
      mapUtils.initMap(this.stat)
    },

    changeTileLayer: function (layer) {
      mapUtils.changeTileLayer(this.stat, layer)
    },

    moveToEnroute: function () {
      this.closeAddressBox()
      this.stat.selectedAirport = ""
      this.stat.selectedAirportIata = ""
      this.stat.selectedAirportIcao = ""
      trackUtils.changeAircraftColor(this.stat, "")
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Rectangle.fromDegrees(126.5, 31.5, 128.5, 39),
      })
    },

    moveToAirportAtStart: function (id) {
      if(id==='GMP'){
        this.stat.selectedAirportTitle = '김포공항'
        this.stat.selectedAirport = 'GMP'
      } else if(id ==='CJU'){
        this.stat.selectedAirportTitle = '제주공항'
        this.stat.selectedAirport = 'CJU'

      } else if(id==='PUS'){
        this.stat.selectedAirportTitle = '김해공항'
        this.stat.selectedAirport = 'PUS'
      }

      this.stat.selectedAirportIata = airportDataIata.location[id].iata
      this.stat.selectedAirportIcao = airportDataIata.location[id].id
      trackUtils.changeAircraftColor(this.stat, id)
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          airportDataIata.location[id].pos[0],
          airportDataIata.location[id].pos[1] - 0.38,
          35000
        ),
        orientation: {
          pitch: Cesium.Math.toRadians(-45.0),
        },
      })
    },

    moveToAirport: function (id) {
      this.stat.selectedAirport = airportData.location[id].name
      this.stat.selectedAirportIata = airportData.location[id].iata
      this.stat.selectedAirportIcao = airportData.location[id].id
      trackUtils.changeAircraftColor(this.stat, id)
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          airportData.location[id].pos[0],
          airportData.location[id].pos[1] - 0.38,
          35000
        ),
        orientation: {
          pitch: Cesium.Math.toRadians(-45.0),
        },
      })
    },

    moveToAddress1: function (x, y) {
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(x, y - 0.225, 25000),
        orientation: {
          pitch: Cesium.Math.toRadians(-45.0),
        },
      })

      this.createAddressDom(x, y)
      this.createAddressVerticalLine(x, y)
    },
    moveToAddress2: function (x, y) {
      this.createAddressDom(x, y)
      this.createAddressVerticalLine(x, y)
    },
    changeAddressAngleTop: function (x, y) {
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(x, y, 25000),
        orientaton: {
          pitch: Cesium.Math.toRadians(-90.0),
        },
      })
    },

    changeAddressAngleBottom: function (x, y) {
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(x, y, 500),
        orientation: {
          pitch: Cesium.Math.toRadians(13.0),
        },
      })
    },

    changeAddressAngleHalf: function (x, y) {
      this.stat.cesiumInstance.viewer.scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(x, y - 0.225, 25000),
        orientation: {
          pitch: Cesium.Math.toRadians(-45.0),
        },
      })
    },

    toggleLayer: function (layer, boolean) {
      for (let i in this.cesiumInstance.viewer.imageryLayers["_layers"]) {
        if (
          this.cesiumInstance.viewer.imageryLayers["_layers"][i][
            "_imageryProvider"
          ]["_layers"] === layer
        ) {
          if (boolean === false) {
            this.cesiumInstance.viewer.imageryLayers["_layers"][i].show = true
          } else {
            this.cesiumInstance.viewer.imageryLayers["_layers"][i].show = false
          }
        }
      }
    },

    createAddressVerticalLine: function (x, y) {
      let entity = null

      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressVerticalPolyline"
        ) {
          entity = this.stat.cesiumInstance.viewer.entities.values[i]
        }
      }

      if (entity) this.stat.cesiumInstance.viewer.entities.remove(entity)

      let newId = uuid()

      this.stat.addressVerticalLineId = newId
      this.stat.cesiumInstance.viewer.entities.add({
        id: newId,
        name: "addressVerticalPolyline",
        show: true,
        polyline: {
          positions: Cesium.Cartesian3.fromDegreesArrayHeights([
            x,
            y,
            0,
            x,
            y,
            10000,
          ]),
          width: 2,
          material: new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.GREENYELLOW,
          }),
        },
      })
    },

    checktimeselector : function (){
      if(this.stat.selectedTime){
        this.$refs.timeselectorRef1.close()
        this.$refs.timeselectorRef2.close()
      } else { 

      } 
    
    },

    createAddressDom: function (x, y) {
      let entity = null
      
      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDom"
        ) {
          entity = this.stat.cesiumInstance.viewer.entities.values[i]
        }
      }
      if (entity) this.stat.cesiumInstance.viewer.entities.remove(entity)
      
      let arr = []
      for (let i in this.stat.cesiumInstance.viewer.entities.values) {
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDistancePolyline"
        ) {
          arr.push(this.stat.cesiumInstance.viewer.entities.values[i].id)
        }
        if (
          this.stat.cesiumInstance.viewer.entities.values[i]["_name"] ===
          "addressDistanceLabel"
        ) {
          arr.push(this.stat.cesiumInstance.viewer.entities.values[i].id)
        }
      }
      for (let i in arr) {
        this.stat.cesiumInstance.viewer.entities.removeById(arr[i])
      }
      let newId = uuid()
      this.stat.addressVerticalLineId = newId
      
      this.stat.cesiumInstance.viewer.entities.add({
        id: newId,
        name: "addressDom",
        show: true,
        position: Cesium.Cartesian3.fromDegrees(x, y),
        ellipsoid: {
          radii: new Cesium.Cartesian3(
            this.stat.domSize,
            this.stat.domSize,
            this.stat.domSize
          ),
          maximumCone: Cesium.Math.PI_OVER_TWO,
          material: Cesium.Color.GREENYELLOW.withAlpha(0.1),
          outline: true,
        },
      })
      
    },

    openRepalyModal: function () {
      setTimeout(() => {
        this.stat.$refs["modal-3"].show()
      }, 200)
    },

    clickMapEntityHandler: function (stat, entity) {
      if (entity) {
        if (entity.id.name === "noiseSensorPoint") {
          this.stat.selectedPlace = entity.id["_description"]["_value"]
          this.stat.selectedPlace.statistics = {}
          this.stat.selectedPlace.pointInfo = this.stat.selectedPlace.NMS_TYPE
          setTimeout(() => {
            this.stat.$refs["modal-2"].show()
          }, 200)
        }
      }
    },

    viewMapList() {
      if (this.viewMap === true) {
        this.viewMap = false
      } else {
        this.viewMap = true
      }
      this.viewInf = false
      this.viewApt = false
      this.viewHelp = false
    },

    //Poller
    startDataProcess: function (stat) {
      stat.startWeatherProcess(stat)
      stat.startScheduleProcess(stat)

      setTimeout(() => {
        stat.startTrackProcessForFlight(stat)
      }, 2000)
      setTimeout(() => {
        stat.startWatchDogProcess(stat)
      }, 2000)
      setTimeout(() => {
        stat.startNoiseProcess(stat)
      }, 2000)

      setTimeout(() => {
        if(this._airport){
          stat.moveToAirportAtStart(this._airport)
        }
      }, 500)
    },

    startWatchDogProcess: function (stat) {
      console.log("CronJob(WatchDog) starts (every 5 sec)")
      stat.watchDogProcess = new CronJob(
        stat.watchDogCronInterval,
        function () {
          trackUtils.startWatchDog(stat)
        },
        null,
        true
      )
      stat.watchDogProcess.start()
    },

    startNoiseProcess: function (stat) {
      stat.noiseProcess = new CronJob(
        stat.noiseProcessCronInterval,
        function () {
          if(stat.isReplayMode) return
          axios
            .get(url[mode.where].noise)
            .then(response => {
              noiseUtils.updateNoise(stat, response.data)
            })
            .catch(err => {
              console.log("Failed to Receive Noise", err)
            })
        },
        null,
        true
      )
      stat.noiseProcess.start()
    },

    startWeatherProcess: function (stat) {
      axios
        .get(url[mode.where].weather)
        .then(response => {
          stat.weatherData = response.data
        })
        .catch(err => {
          console.log("Failed to Receive Weather", err)
        })

      stat.weatherProcess = new CronJob(
        stat.weatherProcessCronInterval,
        function () {
          if(stat.isReplayMode) return
          axios
            .get(url[mode.where].weather)
            .then(response => {
              stat.weatherData = response.data
            })
            .catch(err => {
              console.log("Failed to Receive Weather", err)
            })
        },
        null,
        true
      )
      stat.weatherProcess.start()
    },

    startScheduleProcess: function (stat) {
      axios
        .get(url[mode.where].schedule)
        .then(response => {
          stat.isScheduleData = true
          stat.originalScheduleData = JSON.parse(JSON.stringify(response.data))
          stat.scheduleData = JSON.parse(JSON.stringify(response.data))
        })
        .catch(err => {
          console.log("Failed to Receive Schedule", err)
        })

      stat.scheduleProcess = new CronJob(
        stat.weatherProcessCronInterval,
        function () {
          if(stat.isReplayMode) return
          axios
            .get(url[mode.where].schedule)
            .then(response => {
              stat.isScheduleData = true
              stat.originalScheduleData = JSON.parse(JSON.stringify(response.data))
              stat.scheduleData = JSON.parse(JSON.stringify(response.data))
            })
            .catch(err => {
              console.log("Failed to Receive Schedule", err)
            })
        },
        null,
        true
      )
      stat.scheduleProcess.start()
    },
    startTrackProcessForFlight: function (stat) {
      stat.trackProcess = new CronJob(
        stat.trackProcessCronInterval,
        function () {
          if(stat.isReplayMode) return
          let trackUrl = ""
          if (mode.source === "adsb") {
            if (mode.where === "internal") {
              if (stat.selectedAirportIcao=== "RKPC") {
                trackUrl = url[mode.where].trackAdsbRkpc
              } else if (stat.selectedAirportIcao === "RKSS") {
                trackUrl = url[mode.where].trackAdsbRkss
              } else if (stat.selectedAirportIcao === "RKPK") {
                trackUrl = url[mode.where].trackAdsbRkpk
              }
            }
          } else {
            trackUrl = url[mode.where].track
          }
          axios
            .get(trackUrl)
            .then(response => {
              if (mode.source === "adsb") {
                for (let i in response.data) {
                  stat.extractTrack(stat, response.data[i], "adsb")
                }
              } else {
                for (let i in response.data) {
                  if (Array.isArray(response.data[i])) {
                    if (response.data[i][4] >= 100) {
                      stat.extractTrack(stat, response.data[i], "flight-radar")
                    }
                  }
                }
              }
            })
            .catch(err => {
              console.log("Failed to Receive Track", err)
            })
        },
        null,
        true
      )
      stat.trackProcess.start()
    },

    viewInfList() {
      if (this.viewInf === true) {
        this.viewInf = false
      } else {
        this.viewInf = true
      }
      this.viewMap = false
      this.viewApt = false
      this.viewHelp = false
    },

    extractTrack: function (stat, originData, source) {
      let dataInstance = null
      if (source === "adsb") {
        dataInstance = trackUtils.createDescriptionForAdsb(originData)
      } else if (source === "flight-radar") {
        dataInstance = trackUtils.createDescription(originData)
      }

      if (dataInstance.callSign === "") return
      if (stat.trackData.length === 0) {
        stat.trackData.push(dataInstance)
        stat.cesiumInstance.viewer.entities.add(
          trackUtils.createEntity(
            stat,
            trackUtils.getPosition(dataInstance),
            trackUtils.getOrientation(
              trackUtils.getPosition(dataInstance), 
              trackUtils.getHpr(dataInstance.heading, 0, 0)
            ),
          ),
          dataInstance
        )
      }
      let checker = false
      for (let i in stat.trackData) {
        if (dataInstance.callSign === stat.trackData[i].callSign) {
          if (
            JSON.stringify(stat.trackData[i].pos) ===
            JSON.stringify(dataInstance.pos)
          )
            return
          checker = true
          stat.trackData[i] = dataInstance
        }
      }

      if (checker === false) {
        stat.trackData.push(dataInstance)
        stat.cesiumInstance.viewer.entities.add(
          trackUtils.createEntity(
            stat,
            trackUtils.getPosition(dataInstance),
            trackUtils.getOrientation(
              trackUtils.getPosition(dataInstance),
              trackUtils.getHpr(dataInstance.heading, 0, 0)
            ),
            dataInstance
          )
        )
        trackUtils.createTrackHistoryEntity(stat, dataInstance)
      } else {
        for (let i in stat.cesiumInstance.viewer.entities.values) {
          if (stat.cesiumInstance.viewer.entities.values[i].name === "track") {
            if (
              dataInstance.callSign ===
              stat.cesiumInstance.viewer.entities.values[i].description[
                "_value"
              ].callSign
            ) {
              if(utils.checkMobile()==="ios"||utils.checkMobile()==="android"){

              } else {
                stat.cesiumInstance.viewer.entities.values[i].orientation =
                trackUtils.getOrientation(
                  trackUtils.getPosition(dataInstance),
                  trackUtils.getHpr(dataInstance.heading, 0, 0)
                )
              }
              stat.cesiumInstance.viewer.entities.values[i].position =
                trackUtils.getPosition(dataInstance)
              stat.cesiumInstance.viewer.entities.values[i].label.text[
                "_value"
              ] = dataInstance.placeholder
              stat.cesiumInstance.viewer.entities.values[i].description[
                "_value"
              ] = dataInstance
              trackUtils.addTrackHistoryEntity(stat, dataInstance)
            }
          }
        }
      }
      if (stat.address) {
        trackUtils.addTrackDistanceEntity(stat, dataInstance)
      }
    },
  },
}
</script>

<style>
.modal-xl {
  margin-left: 7.5%;
  width: 85%;
}

.vtimeselector__input{
    border-color: white;
    border-width:0;
    margin-left:10px;
}

.timeselector__box__item--is-selected { 
  background-color: #ff9f43;

}

.vtimeselector{
    border-color: white;
    border-width:0;
    
}

.vtimeselector__box{
    margin-left:10px;
}


@import "./styles/main.css";
@import "./styles/ag-grid/styles/ag-grid.css";
@import "./styles/ag-grid/styles//ag-theme-dark.css";
</style>
